module.exports = __webpack_public_path__ + "static/media/title_rougo.05af638a.svg";